module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19Msw09/tc-custom/9781446356579.jpg?1704318387530",
      "alt": "This image is the cover for the book Bake Me I'm Yours . . . Cupcake Fun, Bake Me I'm Yours . . ."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bake Me I'm Yours . . . Cupcake Fun, Bake Me I'm Yours . . .\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A guide to creating delicious cupcakes—and characters to top them off, from animals to aliens—by an expert in cake decoration.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Discover how to bake perfect cupcakes every time with easy-to-follow recipes and clever tips for professional results. You will also learn essential cake decorating techniques, including buttercream piping and creating character features with sugarpaste and rolled fondant icing—perfect for making unique cupcake designs!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Enjoy making fun cupcake characters, from barnyard animals, nurses, and firemen to pirates, mermaids, and space aliens. You’ll also find delicious cupcake recipes for every occasion:"), _c('br'), _vm._v(" · Banana and Macadamia"), _c('br'), _vm._v(" · Blueberry and Almond"), _c('br'), _vm._v(" · Chocolate Brownie"), _c('br'), _vm._v(" · Classic Vanilla"), _c('br'), _vm._v(" · Double Chocolate"), _c('br'), _vm._v(" · Strawberry Jam Surprise and lots more!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn White\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carolyn White runs the London-based cake decorating shop and online store Cakes4Fun, which encompasses novelty cakes, celebration cakes, corporate and wedding cakes. Cakes4Fun also provides a huge variety of cake decorating and sugar modelling courses for cake enthusiasts of any level, from beginner to expert. Carolyn is the author of Bake Me I'm Yours...Cake Pops and Bake Me I'm Yours...Cupcake Fun. www.cakes4fun.co.uk")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0